import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Language } from './salesforce-types';

export const LANGUAGE = new InjectionToken<BehaviorSubject<Language>>('language', {
  providedIn: 'root',
  factory: () => new BehaviorSubject(Language.En),
});
